import config from '../config';
import Auth from './Auth';
import { FileRecord } from './Learning';
import moment from 'moment';

export default class Utils {
    public static concatStrings = (...strings: Array<String>) => {
        return strings.map(str => str && str.trim()).filter(str => str).join(' ');
    }

    public static getFileUrl = (fileRecord: FileRecord) => {
        return (fileRecord && fileRecord.id > 0) ? `${config.filesEndpoint}?id=${fileRecord.id}&sessionKey=${Auth.getSessionKey()}` : null;
    }
    
    public static dateTimeToStr = (date: Date) => {
        return date ? moment(date).format('DD.MM.YY HH:mm') : '';
    }

    public static dateTimeToFullStr = (date: Date) => {
        return date ? moment(date).format('DD.MM.YY HH:mm:ss') : '';
    }

    public static numberToStr = (number: number): string => {
        return number.toFixed(2);
    }    
}